// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDxaJThRDuSfgEi1QhZ3B2-WkRnKM9vTPE",
    authDomain: "universaldrivenl.firebaseapp.com",
    projectId: "universaldrivenl",
    storageBucket: "universaldrivenl.firebasestorage.app",
    messagingSenderId: "645653292322",
    appId: "1:645653292322:web:d514d2738912bdc794317b",
    measurementId: "G-3TZ1G4S90C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };